import {
	initialNewBankAccounts,
	initialNewUsers,
	setActiveStepIdx,
	setError,
	setIsDirty,
	setLoading,
	setNewAccount,
	setNewBankAccount,
	setNewUsers,
} from 'state/reducers/new_accounts.reducers';
import { apiFunctionsEnum } from 'constants/api.constants';
import ApiService from './api.service';
import {
	setAccountsInProcess,
	setFinishProcess,
	setNewAccountId,
	setNewBankAccounts,
	setNewUser,
	setUserAddedSuccesfully,
} from 'state/reducers/new_accounts.reducers';
import FormData from 'form-data';
import { setErrorMessage } from 'utils/index';
import _ from 'lodash';
import { continueOptions, newAccountsSteps } from 'constants/new_accounts.constants';
import { createAsyncThunk } from '@reduxjs/toolkit';

export function getNewAccounts(getAll?: boolean) {
	return async (dispatch: any) => {
		dispatch(setLoading(true));
		dispatch(setError({ exist: false }));
		const payload = getAll ? { includeByCreator: true } : {};
		await ApiService.getInstance()
			.execute(apiFunctionsEnum.GET_NEW_ACCOUNTS, payload)
			.then((response: any) => {
				dispatch(setAccountsInProcess(response.data.newAccounts));
			})
			.catch((error: any) => {
				setErrorMessage(setError, {
					errorNumber: error?.response?.data?.error_number,
					statusCode: error?.response?.status,
				});
			})
			.finally(() => {
				dispatch(setLoading(false));
			});
	};
}

export function getNewAccountById(id: any) {
	return async (dispatch: any) => {
		dispatch(setLoading(true));
		dispatch(setError({ exist: false }));
		await ApiService.getInstance()
			.execute(apiFunctionsEnum.GET_NEW_ACCOUNT_BY_ID, { id })
			//.execute(`${apiFunctionsEnum.GET_NEW_ACCOUNT_BY_ID}/${id}`)
			.then((response: any) => {
				dispatch(setNewAccount(response.data.newAccount));
			})
			.catch((error: any) => {
				console.log(error);
			})
			.finally(() => {
				dispatch(setLoading(false));
			});
	};
}

export function getNewUsersByAccountId(id: any) {
	return async (dispatch: any) => {
		dispatch(setLoading(true));
		dispatch(setError({ exist: false }));
		await ApiService.getInstance()
			.execute(apiFunctionsEnum.GET_NEW_USERS_BY_ACCOUNT_ID, { id })
			.then((response: any) => {
				dispatch(initialNewUsers(_.keyBy(response.data.newUsers, 'id')));
			})
			.catch((error: any) => {
				console.log(error);
			})
			.finally(() => {
				dispatch(setLoading(false));
			});
	};
}

export function getNewBankAccountByAccountId(id: any) {
	return async (dispatch: any) => {
		dispatch(setLoading(true));
		dispatch(setError({ exist: false }));
		await ApiService.getInstance()
			.execute(apiFunctionsEnum.GET_NEW_BANK_ACCOUNTS_BY_ACCOUNT_ID, { id })
			.then((response: any) => {
				dispatch(setLoading(false));
				dispatch(initialNewBankAccounts(_.keyBy(response.data.newBankAccounts, 'id')));
			})
			.catch((error: any) => {
				console.log(error);
			})
			.finally(() => {
				dispatch(setLoading(false));
			});
		19;
	};
}

export function upsertAccount(data: any) {
	return async (dispatch: any) => {
		dispatch(setLoading(true));
		await ApiService.getInstance()
			.execute(apiFunctionsEnum.UPSERT_ACCOUNT, data)
			.then((response: any) => {
				dispatch(setNewAccount(response.data.newAccount));
				dispatch(setNewAccountId(response.data.newAccount.id));
				dispatch(setActiveStepIdx(2));
			})
			.catch((error: any) => {
				setNewAccountFieldsErrorMessage(dispatch, error);
			})
			.finally(() => {
				dispatch(setLoading(false));
			});
	};
}

export function upsertUser(data: any, continueOption?: string) {
	const { newUsers, newAccountId } = data;
	return async (dispatch: any, getState: any) => {
		dispatch(setLoading(true));
		await ApiService.getInstance()
			.execute(apiFunctionsEnum.UPSERT_USER, { newUsers, newAccountId })
			.then((response: any) => {
				dispatch(setUserAddedSuccesfully(true));
				const newUser = response?.data?.newUsers[0];
				setAccountsInProcess;
				const { newAccount, translation } = getState();
				const addNewUser = {};
				if (continueOption === continueOptions.SAVE_AND_NEW) {
					const add_user = _.get(
						translation?.translations?.he,
						'page.accounts.new_account.user_details.add_user'
					)?.value;
					const initialNewUser = {
						id: 'new',
						firstNameHebrew: '*' + add_user,
					};
					dispatch(setNewUser(initialNewUser));
					dispatch(
						setIsDirty({
							dirty: true,
							type: newAccountsSteps.USER_DETAILS,
						})
					);
					_.assign(addNewUser, { new: initialNewUser });
				}
				if (continueOption === continueOptions.SAVE_AND_CONTINUE) {
					dispatch(setActiveStepIdx(3));
				}
				dispatch(
					initialNewUsers({ ..._.omit(newAccount.newUsers, 'new'), [newUser.id]: newUser, ...addNewUser })
				);
			})
			.catch((error: any) => {
				dispatch(setUserAddedSuccesfully(false));
				console.log(error);
			})
			.finally(() => {
				dispatch(setLoading(false));
			});
	};
}

export function deleteNewUser(data: any, continueOption?: string) {
	const { id } = data;
	return async (dispatch: any, getState: any) => {
		dispatch(setLoading(true));
		await ApiService.getInstance()
			.execute(apiFunctionsEnum.DELETE_USER, { id })
			.then((response: any) => {
				dispatch(setUserAddedSuccesfully(true));
				const { newAccount, translation } = getState();
				const addNewUser = {};
				dispatch(initialNewUsers({ ..._.omit(newAccount.newUsers, id), ...addNewUser }));
			})
			.catch((error: any) => {
				dispatch(setUserAddedSuccesfully(false));
				console.log(error);
			})
			.finally(() => {
				dispatch(setLoading(false));
			});
	};
}

export function deleteNewBankAccount(data: any, continueOption?: string) {
	const { id } = data;
	return async (dispatch: any, getState: any) => {
		dispatch(setLoading(true));
		await ApiService.getInstance()
			.execute(apiFunctionsEnum.DELETE_BANK_ACCOUNT, { id })
			.then((response: any) => {
				const { newAccount, translation } = getState();
				const addNewUser = {};
				dispatch(initialNewBankAccounts({ ..._.omit(newAccount.newBankAccounts, id), ...addNewUser }));
			})
			.catch((error: any) => {
				dispatch(setUserAddedSuccesfully(false));
				console.log(error);
			})
			.finally(() => {
				dispatch(setLoading(false));
			});
	};
}

export function upsertBankAccount(data: any, continueOption?: string) {
	const { bankAccountData, newAccountId, file } = data;
	const formData = new FormData();
	const originFile = bankAccountData.file;
	const _bankAccountData = _.omit({ ...bankAccountData }, 'file');
	if (!_.has(originFile, 'newAccountId')) {
		formData.append('file', originFile, originFile?.name);
	} else {
		formData.append('fileId', originFile?.id);
	}
	Object.keys(_bankAccountData).map((key: any) => {
		formData.append(key, _bankAccountData[`${key}`]);
	});
	formData.append('newAccountId', Number(newAccountId));
	return async (dispatch: any, getState: any) => {
		dispatch(setLoading(true));
		await ApiService.getInstance()
			.execute(apiFunctionsEnum.UPSERT_BANK_ACCOUNT, formData, { 'Content-Type': 'multipart/form-data' })
			.then((response: any) => {
				const newBankAccount = response?.data?.newBankAccount;
				const { newAccount, translation } = getState();
				const addNewBankAccount = {};
				let _newBankAccount = { ...newBankAccount };
				if (!_.has(originFile, 'newAccountId')) {
					formData.append('file', originFile, originFile?.name);
				} else {
					formData.append('fileId', originFile?.id);
				}
				if (continueOption === continueOptions.SAVE_AND_NEW) {
					const add_bankAccount = _.get(
						translation?.translations?.he,
						'page.accounts.new_account.user_details.bankAccount'
					)?.value;

					const initialNewBankAccount = {
						id: 'new',
						accountOwnerName: '*' + add_bankAccount,
						bankId: '',
						bankBranch: '',
						accountNumber: '',
					};
					_newBankAccount = initialNewBankAccount;
					dispatch(
						setIsDirty({
							dirty: true,
							type: newAccountsSteps.BANK_ACCOUNT_DETAILS,
						})
					);
					_.assign(addNewBankAccount, { new: initialNewBankAccount });
				}
				if (continueOption === continueOptions.SAVE_AND_CONTINUE) {
					dispatch(sendToReview(newBankAccount.newAccountId));
				}
				const payload = {
					..._.omit(newAccount.newBankAccounts, 'new'),
					[newBankAccount.id]: {
						...newAccount.newBankAccount,
						...newBankAccount,
						bankId: Number(newBankAccount?.bankId),
					},
					...addNewBankAccount,
				};
				dispatch(setNewBankAccount(_newBankAccount));
				dispatch(initialNewBankAccounts(payload));
			})
			.catch((error: any) => {
				console.log(error);
				//dispatch(setFinishProcess(false));
			})
			.finally(() => {
				dispatch(setLoading(false));
			});
	};
}

export function sendToReview(newAccountId: any) {
	return async (dispatch: any) => {
		setLoading(true);
		await ApiService.getInstance()
			.execute(apiFunctionsEnum.SEND_ACCOUNT_TO_REVIEW, { newAccountId })
			.then(() => {
				dispatch(setFinishProcess(true));
			})
			.catch((error: any) => {
				dispatch(setFinishProcess(false));
			})
			.finally(() => {
				dispatch(setLoading(false));
			});
	};
}

function setNewAccountFieldsErrorMessage(dispatch: any, error: any) {
	const invalidFields = error?.response?.data?.invalidFields;
	if (invalidFields) {
		dispatch(
			setError({
				exist: true,
				text: 'page.accounts.new_account.approve.invalid_fields',
				subText: invalidFields,
			})
		);
		return;
	}
	setErrorMessage(setError, {
		errorNumber: error?.response?.data?.error_number,
		statusCode: error?.response?.status,
	});
}

export function approveCustomerDetails(newAccountId: any) {
	return async (dispatch: any) => {
		dispatch(setLoading(true));
		await ApiService.getInstance()
			.execute(apiFunctionsEnum.APPROVE_NEW_ACCOUNT_CUSTOMER_DETAILS, { newAccountId })
			.then((response: any) => {
				dispatch(setNewAccount(response.data.newAccount));
				dispatch(setNewAccountId(response.data.newAccount.id));
				dispatch(setActiveStepIdx(2));
			})
			.catch((error: any) => {
				setNewAccountFieldsErrorMessage(dispatch, error);
			})
			.finally(() => {
				dispatch(setLoading(false));
			});
	};
}

export function approveUserDetails(newUserId: any, newAccountId: any) {
	return async (dispatch: any) => {
		dispatch(setLoading(true));
		await ApiService.getInstance()
			.execute(apiFunctionsEnum.APPROVE_NEW_ACCOUNT_USERS, { newUserId, newAccountId })
			.then((response: any) => {
				dispatch(setNewUser(response.data.newUser));
				dispatch(setNewUsers({ [newUserId]: response.data.newUser }));
			})
			.catch((error: any) => {
				setErrorMessage(setError, {
					errorNumber: error?.response?.data?.error_number,
					statusCode: error?.response?.status,
				});
			})
			.finally(() => {
				dispatch(setLoading(false));
			});
	};
}

export function approveBankAccountDetails(newBankAccountId: any, newAccountId: any) {
	return async (dispatch: any) => {
		dispatch(setLoading(true));
		await ApiService.getInstance()
			.execute(apiFunctionsEnum.APPROVE_NEW_ACCOUNT_BANK_ACCOUNTS, { newBankAccountId, newAccountId })
			.then((response: any) => {
				dispatch(setNewBankAccount(response.data.newBankAccount));
				dispatch(setNewBankAccounts({ [newBankAccountId]: response.data.newBankAccount }));
			})
			.catch((error: any) => {
				setErrorMessage(setError, {
					errorNumber: error?.response?.data?.error_number,
					statusCode: error?.response?.status,
				});
			})
			.finally(() => {
				dispatch(setLoading(false));
			});
	};
}

export function approveAllSteps(newAccountId: any, boNotes?: any) {
	return async (dispatch: any) => {
		dispatch(setLoading(true));
		await ApiService.getInstance()
			.execute(apiFunctionsEnum.APPROVE_NEW_ACCOUNT, { newAccountId, boNotes })
			.then((response: any) => {
				dispatch(setFinishProcess(true));
			})
			.catch((error: any) => {
				setNewAccountFieldsErrorMessage(dispatch, error);
			})
			.finally(() => {
				dispatch(setLoading(false));
			});
	};
}

export async function getExistContact(email: string) {
	return await ApiService.getInstance().execute(apiFunctionsEnum.GET_EXIST_CONTACT, {
		email,
	});
}

export function deleteNewAccountAndCompany(id: number) {
	return async (dispatch: any) => {
		dispatch(setLoading(true));
		dispatch(setError({ exist: false }));
		await ApiService.getInstance()
			.execute(apiFunctionsEnum.DELETE_NEW_ACCOUNT_AND_COMPANY, { id })
			.then((response: any) => {
				// Success response - refresh the accounts list
				dispatch(getNewAccounts(true));
				return response;
			})
			.catch((error: any) => {
				setErrorMessage(setError, {
					errorNumber: error?.response?.data?.error_number,
					statusCode: error?.response?.status,
				});
				throw error;
			})
			.finally(() => {
				dispatch(setLoading(false));
			});
	};
}
